export const isBankTransferMissingRef = (record, reference = record?.reference) =>
  (record?.PaymentMethod?.key ?? record?.paymentMethod?.key) === 'bank_transfer' &&
  !String(reference ?? '').trim();
